import axios from 'axios';

const API_BASE = '/api/forms';

const resolveToken = (token) => token || sessionStorage.getItem('token');

const buildConfig = (token, comCode) => {
  const headers = {
    Authorization: `Bearer ${resolveToken(token)}`,
  };
  if (comCode) {
    headers['x-com-code'] = comCode;
  }
  return { headers };
};

// 📑 결재양식 목록 조회
export const getForms = async (token, comCode) => {
  const res = await axios.get(API_BASE, buildConfig(token, comCode));
  return res.data;
};

// 📑 결재양식 단건 조회
export const getFormByCode = async (formCode, token, comCode) => {
  const res = await axios.get(`${API_BASE}/${formCode}`, buildConfig(token, comCode));
  return res.data;
};

export const createForm = async (data, token, comCode) => {
  const payload = {
    ...data,
    parent_code: data.parent_code && data.parent_code.trim() !== '' 
      ? data.parent_code 
      : 'root',   // ✅ parent_code가 없으면 root로 저장
  };

  const res = await axios.post('/api/forms', payload, buildConfig(token, comCode));
  return res.data;
};


// 📑 결재양식 수정
export const updateForm = async (formCode, data, token, comCode) => {
  const res = await axios.put(`${API_BASE}/${formCode}`, data, buildConfig(token, comCode));
  return res.data;
};

// 📑 결재양식 삭제
export const deleteForm = async (formCode, token, comCode) => {
  const res = await axios.delete(`${API_BASE}/${formCode}`, buildConfig(token, comCode));
  return res.data;
};

// 📑 권한 목록 조회
export const getFormAuths = async (formCode, token, comCode) => {
  const res = await axios.get(`${API_BASE}/${formCode}/auth`, buildConfig(token, comCode));
  return res.data;
};

// 📑 권한 추가
export const addFormAuth = async (formCode, data, token, comCode) => {
  const res = await axios.post(`${API_BASE}/${formCode}/auth`, data, buildConfig(token, comCode));
  return res.data;
};

// 📑 권한 삭제
export const deleteFormAuth = async (formCode, targetType, targetId, token, comCode) => {
  const res = await axios.delete(`${API_BASE}/${formCode}/auth/${targetType}/${targetId}`, buildConfig(token, comCode));
  return res.data;
};


// 📑 트리 구조 조회
export const getFormsTree = async (token, comCode) => {
  const res = await axios.get(`${API_BASE}?view=tree`, buildConfig(token, comCode));
  return res.data;
};